var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-0 h-100"},[_vm._m(0),_c('order-pulls-config-grid')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v("OrderPulls "),_c('strong',[_vm._v("config")])])
}]

export { render, staticRenderFns }